<div class="contact-container">
    <div class="location">
        <div class="location-container">
            <p class="address"><b>ADDRESS</b></p>
            <div class="contact">
                <p><i class="fa-solid fa-church"></i> 1001 Mullins St. <br> &nbsp; &nbsp; &nbsp;Irving, TX <br> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;75061</p>
                <p><i class="fa-solid fa-phone"></i> &nbsp;469-663-8737</p> 
                <p><i class="fa-solid fa-envelope"></i>&nbsp; stgabriel@gmail.com</p> 
            </div>  
            <button class="button">BE A MEMBER</button>
        </div>
    </div>
</div>
